import React from 'react'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import { useIntl } from 'react-intl'

import { Loading } from '../../../../components/Loading'

function PipelineLoadingSiteConfigCard() {
	const { formatMessage } = useIntl()

	return (
		<Card sx={{ width: '100%' }}>
			<CardContent>
				<Loading size="small" />
				<Typography textAlign="center">
					{formatMessage({ id: 'site_configuration.loading' })}
				</Typography>
			</CardContent>
		</Card>
	)
}

export default PipelineLoadingSiteConfigCard
